export default "__VITE_ASSET__a559f3cb__"